module.exports = __webpack_public_path__ + "img/num_5.83b0eeac.png";